<template>
    <row>
        <column v-if="!clubStore.club.is_managed" cols="12">
            <lazy-request-management-card :model="clubStore.club" mobile-tile/>
        </column>
        <template v-else>
            <column cols="12" :md="7" :lg="8">
                <card xs-tile sm-tile>
                    <card-subtitle>{{ $t('view.clubs.join.index.description', {club: clubStore.club.display_name}) }}</card-subtitle>
                    <card-text>
                        <group-join-page :code="invitationCode" :token="memberToken" :group="clubStore.club" :auth-relations="clubStore.authPermissions" @accepted="handleAcceptedMembership" @declined="handleDeclinedMembership" @requested="handleSentRequest"/>
                    </card-text>
                </card>
			</column>
        </template>
    </row>
</template>

<script setup lang="ts">
import {useClubStore} from "../../../store/club";
const clubStore = useClubStore();
const {t} = useI18n();
const route = useRoute();
const {$api, $analytics} = useNuxtApp();

const invitationCode = route.query.code;
const memberToken = route.query.token;

function handleAcceptedMembership() {
	clubStore.refreshAuthPermissions(); // TODO: Use
	clubStore.club.accepted_members_count++;
	trackJoinedClub();
}

function handleDeclinedMembership() {
	clubStore.refreshAuthPermissions();
}

function handleSentRequest() {
	clubStore.refreshAuthPermissions();
	trackJoinedClub();
}

function trackJoinedClub() {
	$analytics.trackEvent('join_group', {
		group_id: `${clubStore.club.model_name}-${clubStore.club.id}`,
		group_name: clubStore.club.display_name
	});
}

useMeta({
	title: clubStore.buildPageTitle(t('view.clubs.join.index.title', {club: clubStore.club.display_name})),
	description: t('view.clubs.join.index.description', {club: clubStore.club.display_name}),
	noIndex: true
})

</script>

